import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData, ImageLoadingStrategy, MediaContainer } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { InteractiveCarouselLoadingStrategyService } from '../../interactive-carousel/interactive-carousel-loading-strategy.service';
import { GgTransparentBoxCmsData } from './gg-transparent-box/gg-transparent-box.component';

export interface GgMainIntroSliderItemComponent {
  uid: string;
  image?: MediaContainer;
  mobileImage?: MediaContainer;
  transparentBox?: GgTransparentBoxCmsData;
  button?: CmsLinkComponent;
  button2?: CmsLinkComponent;
  styleClasses?: string;
  cssColorClass?: string;
}

@Component({
  selector: 'app-gg-main-intro-slider-item',
  templateUrl: 'gg-main-intro-slider-item.component.html',
  standalone: false,
})
export class GgMainIntroSliderItemComponent implements OnInit {
  private componentData = inject(CmsComponentData<GgMainIntroSliderItemComponent>);
  private loadingStrategyService = inject(InteractiveCarouselLoadingStrategyService);
  private destroyRef = inject(DestroyRef);

  data$: Observable<GgMainIntroSliderItemComponent> = this.componentData.data$;
  loadingStrategy: ImageLoadingStrategy | null = null;

  ngOnInit(): void {
    this.data$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      if (data) {
        this.loadingStrategy = this.loadingStrategyService.getLoadingStrategy(data);
      }
    });
  }

  getTarget(data: any): string | null {
    return data === 'true' || data === true ? '_blank' : null;
  }
}
